export type EventData = {
  eventType: string;
  eventPayload?: object;
};

export type HostEventData<T = object> = {
  eventType: string;
} & T;

export const parseHostEvent = <T extends object>(
  event: string,
): HostEventData<T> => {
  const emptyData: EventData = {
    eventType: '',
    eventPayload: {},
  };

  try {
    const data = JSON.parse(event) as { args?: EventData };
    const { eventType, eventPayload = {} } = data?.args ?? emptyData;

    return { eventType, ...eventPayload } as HostEventData<T>;
  } catch {
    return {
      eventType: '',
    } as HostEventData<T>;
  }
};
